/*Flip Arrow of Mobile Menu*/
function toggle_drawer_menu_icon_right() {

  var icon_menu = document.getElementById("mobile_menu_arrow_right");
  var background_header = document.getElementById("nav_mobile");
  var current_icon = icon_menu.getAttributeNS("http://www.w3.org/1999/xlink", "href");
    if (current_icon === "https://cdn.shopify.com/s/files/1/0027/7240/2287/files/MenuOpening.svg") {
    icon_menu.setAttributeNS("http://www.w3.org/1999/xlink","xlink:href", "https://cdn.shopify.com/s/files/1/0027/7240/2287/files/Frame.svg");
              setTimeout(function() {
background_header.setAttribute("style", "background-color:#E3D6B5;");

    }, 0);
    
  } else {
    icon_menu.setAttributeNS("http://www.w3.org/1999/xlink","xlink:href", "https://cdn.shopify.com/s/files/1/0027/7240/2287/files/MenuOpening.svg");
    background_header.setAttribute("style", "background-color:#F8F6F0;");
  }

}

function toggle_drawer_menu_icon_left() {
  var icon_menu = document.getElementById("mobile_menu_arrow_left");
  var background_header = document.getElementById("nav_mobile");
  var current_icon = icon_menu.getAttributeNS("http://www.w3.org/1999/xlink", "href");
    if (current_icon === "https://cdn.shopify.com/s/files/1/0027/7240/2287/files/MenuOpening.svg") {
    icon_menu.setAttributeNS("http://www.w3.org/1999/xlink","xlink:href", "https://cdn.shopify.com/s/files/1/0027/7240/2287/files/Frame.svg");
      background_header.setAttribute("style", "background-color:#E3D6B5;");
  } else {
    icon_menu.setAttributeNS("http://www.w3.org/1999/xlink","xlink:href", "https://cdn.shopify.com/s/files/1/0027/7240/2287/files/MenuOpening.svg");
       background_header.setAttribute("style", "background-color:#F8F6F0;");
  }

}



/*Header Color & Image Change*/

/*
document.getElementById('logo_change_dekstop').addEventListener('mouseover', function() {
  this.srcset = 'https://cdn.shopify.com/s/files/1/0027/7240/2287/files/Moro_Dabron_Grey.png?v=1666769405';
});


document.getElementById('logo_change_dekstop').addEventListener('mouseout', function() {
  this.srcset = 'https://cdn.shopify.com/s/files/1/0027/7240/2287/files/Moro_Dabron_Logo_1_6b5d1b73-40fa-42b4-ab97-d7bb26fff191.png?v=1666728323';
});



document.getElementById('logo_change_mobile').addEventListener('mouseover', function() {
  this.srcset = 'https://cdn.shopify.com/s/files/1/0027/7240/2287/files/Moro_Dabron_Grey.png?v=1666769405';
});

document.getElementById('logo_change_dekstop').addEventListener('mouseout', function() {
  this.srcset = 'https://cdn.shopify.com/s/files/1/0027/7240/2287/files/Moro_Dabron_Logo_1_6b5d1b73-40fa-42b4-ab97-d7bb26fff191.png?v=1666728323';
});
*/

/*Fill Cart Popup Dynamically when product is added*/
document.addEventListener('ajaxProduct:added', function(evt) {
  var value = $("[name='quantity']");
  $('.cart_popup_display').css('display', 'none');

  var current_cart_quantity_text = $("#cart_bubble_quantity").text(); // e.g., "(3)"
  var current_cart_quantity = parseInt(current_cart_quantity_text.replace(/[()]/g, ''));

  if (isNaN(current_cart_quantity)) {
    current_cart_quantity = 0;
  }

  var quantity_to_add = parseInt(value.val());
  if (isNaN(quantity_to_add)) {
    quantity_to_add = 1; // default to 1 if quantity field is invalid
  }

  var quantity_to_update = current_cart_quantity + quantity_to_add;
  $("#cart_bubble_quantity").text('(' + quantity_to_update + ')');
});



  function updateSecondaryVisibility() {
    const wrapper = document.querySelector('.slide-nav__wrapper');
    const secondaryElements = document.querySelectorAll('.secondary_hide');

    if (!wrapper) return;

    const level = wrapper.getAttribute('data-level');
    secondaryElements.forEach(el => {
      if (level !== '1') {
        el.style.display = 'none';
      } else {
        el.style.display = 'block';
      }
    });
  }

  // Run on page load
  document.addEventListener('DOMContentLoaded', function() {
    updateSecondaryVisibility();

    // Monitor changes to data-level using MutationObserver
    const wrapper = document.querySelector('.slide-nav__wrapper');
    if (!wrapper) return;

    const observer = new MutationObserver(updateSecondaryVisibility);

    observer.observe(wrapper, {
      attributes: true,
      attributeFilter: ['data-level']
    });
  });


